import SpriteSymbol from "../../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-pinglun",
  "use": "icon-pinglun-usage",
  "viewBox": "0 0 16.94 13.93",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 16.94 13.93\" id=\"icon-pinglun\">\n  <path id=\"icon-pinglun_回答\" class=\"cls-1\" d=\"M2004.94,1279.61a1.552,1.552,0,0,1-.96-0.33l-1.82-1.43h-4.15a1.53,1.53,0,0,1-1.54-1.52v-9.16a1.539,1.539,0,0,1,1.54-1.53h13.86a1.539,1.539,0,0,1,1.54,1.53v9.16a1.53,1.53,0,0,1-1.54,1.52h-4.19l-1.78,1.42A1.5,1.5,0,0,1,2004.94,1279.61Zm-6.93-12.95a0.512,0.512,0,0,0-.51.51v9.16a0.512,0.512,0,0,0,.51.51h4.5l2.11,1.64a0.511,0.511,0,0,0,.64,0l2.06-1.64h4.55a0.514,0.514,0,0,0,.52-0.51v-9.16a0.514,0.514,0,0,0-.52-0.51h-13.86Zm10.27,3.05h-8.22a0.505,0.505,0,1,1,0-1.01h8.22A0.505,0.505,0,1,1,2008.28,1269.71Zm-3.08,3.06h-5.14a0.51,0.51,0,1,1,0-1.02h5.14A0.51,0.51,0,0,1,2005.2,1272.77Z\" transform=\"translate(-1996.47 -1265.66)\" />\n</symbol>"
});
var result = sprite.add(symbol);
export default symbol


//////////////////
// WEBPACK FOOTER
// ./src/assets/svgs/svg/pinglun.svg
// module id = 8cts
// module chunks = 41